/**
 * Carousel Element Visibility Rules
 * 
 * Controls visibility of carousel share/like buttons based on experiments.
 */

import { AllowedExperimentKey } from '@tenants/types';
import { ExperimentElement, type Rule, type VisibilityContext } from '../../types';

/**
 * Carousel buttons have complex viewport-specific logic
 * 
 * Desktop: hide if LISTING_HERO OR STICKY_HEADER_TABS active  
 * Mobile: hide ONLY if LISTING_HERO active (STICKY_HEADER_TABS doesn't hide carousel on mobile)
 * 
 * Rationale: On mobile, sticky header tabs don't include action buttons,
 * so carousel buttons remain visible unless hero experiment is active.
 * 
 * Solution: Use custom functions instead of declarative rules
 */

const carouselButtonRule = (context: VisibilityContext): boolean => {
  const { experiments, viewport } = context;
  
  if (viewport === 'desktop') {
    // Desktop: hide if either experiment is active
    return !experiments[AllowedExperimentKey.LISTING_HERO] && 
           !experiments[AllowedExperimentKey.STICKY_HEADER_TABS];
  }
  
  // Mobile: hide only if LISTING_HERO is active
  return !experiments[AllowedExperimentKey.LISTING_HERO];
};

export const carouselRules: Partial<Record<ExperimentElement, Rule>> = {
  [ExperimentElement.CAROUSEL_SHARE_BUTTON]: carouselButtonRule,
  [ExperimentElement.CAROUSEL_LIKE_BUTTON]: carouselButtonRule,
};
